import Plugin from '../core/Plugin';
import LiveReporter from './report/LiveReporter';
import VodReporter from './report/VodReporter';
import VhyReporter from '@vhallyun/log-reporter';

/**
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

/**
 * 日志上报插件
 *
 * @export
 * @class Reporter
 * @extends {Plugin}
 */
export default class Reporter extends Plugin {
  constructor() {
    super();
  }

  init(opts = {}) {
    super.init(opts);
    this._allConfig = opts;
    //是否启用
    this._reporterCfg = JSON.parse(opts[Reporter.type]);
    if (this._reporterCfg.enable === false) {
      return;
    }

    let isLive = this._allConfig.isLive;
    this.r = isLive ? new LiveReporter() : new VodReporter();
    this.r.allConfig = opts;
    this.r.player = this.player;
    this.r.setReportConfig(opts[Reporter.type], opts['other_option']);

    // 启用定时器心跳上报
    this.r.start();
  }

  destroy() {
    super.destroy();
    this.r.destroy();
  }

  static get type() {
    return 'plugin_reporter';
  }
}
